import React, { useState, useEffect } from 'react';
import { Checkbox } from 'antd';
import { BookOutlined } from '@ant-design/icons';
// import PropTypes from "prop-types";
import { Button as MuiButton } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { SUBSCRIPTION_DELIVERY, SUBSCRIPTION_PAYMENT } from '../../route/AppRouter';
import road from '../../assets/images/road.svg';
import car from '../../assets/images/car.svg';
import { Affix } from 'antd';

const ContractForm = (prop) => {
    const { register, handleSubmit, setValue, errors, setError, clearError } = useForm();

    const [checker, setChecker] = useState(false);
    const history = useHistory();
    const location = useLocation();

    const onSubmit = (data) => {
        // console.log("data: ", checker)
        if (checker) {
            history.push({
                pathname: `${SUBSCRIPTION_DELIVERY}`,
                search: location.search,
            });
        } else {
            setError('agree_trems', 'not-match', 'Please check the aggrement.');
        }
    };

    useEffect(() => {
        register({ name: 'agree_trems', required: true });
    });

    const handleCheck = (e) => {
        setValue('agree_trems', e.target.checked);
        setChecker(e.target.checked);
        clearError('agree_trems');
    };

    // const onNext = () => {
    //   history.push({
    //     pathname: `${SUBSCRIPTION_DELIVERY}`,
    //     search: location.search,
    //   });
    // };

    const onBack = () => {
        history.push({
            pathname: `${SUBSCRIPTION_PAYMENT}`,
            search: location.search,
        });
    };

    return (
        <div className="formStatus">
            <form test_id="subscription-contract-form" className="contract-form" onSubmit={handleSubmit(onSubmit)}>
                <div className="contract-label-container">
                    <BookOutlined className="contract-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="contract-label">Contract (Easy Lease Agreement)</h4>
                </div>
                <div className="contract-content">
                    <h3 className="blockTitle">WHEREAS</h3>

                    <ul className="tAndCList">
                        <li>
                            <span>A</span>The Owner is the registered owner of the vehicle subject of this Yoma Fleet
                            Easy Lease Agreement and shall remain the Owner throughout the lease term.
                        </li>
                        <li>
                            <span>B</span>The Owner shall let and the Lessor shall take on lease such vehicle as agreed
                            between the Owner and the Lessor.
                        </li>
                        <li>
                            <span>C</span>The Owner and the Lessor are entering into this Yoma Fleet Easy Lease
                            Agreement to facilitate the lease of such vehicle.
                        </li>
                        <li>
                            <span>D</span>If the Owner wishes to lease to the Lessor (and the Lessor wishes to take on
                            lease from the Owner) a vehicle, the Owner and the Lessor shall sign a lease schedule in
                            respect of that vehicle the subject of a lease at the same time (“Schedule”) in the form
                            attached hereto as an attachment.{' '}
                        </li>
                    </ul>

                    <h3>WHEREBY IT IS AGREED AS FOLLOWS:-</h3>

                    <h4>1. Definitions</h4>

                    <p>
                        In this Yoma Fleet Easy Lease Agreement the following expressions shall have the following
                        meanings:-
                    </p>

                    <ul className="tAndCList">
                        <li>
                            <span>1.1</span>‘this Agreement’ or ‘this Yoma Fleet Easy Lease Agreement’ refers to this
                            Yoma Fleet Easy Lease Agreement entered into on the date herein written.
                        </li>
                        <li>
                            <span>1.2</span>’the Vehicle’ means the vehicle specified in a Schedule.{' '}
                        </li>
                        <li>
                            <span>1.3</span>‘the Rental’ means the rental specified in a Schedule.
                        </li>
                        <li>
                            <span>1.4</span>‘we, us and our’ refer to the Owner.
                        </li>
                        <li>
                            <span>1.5</span>‘you and your’ refer to the Lessor.
                        </li>
                        <li>
                            <span>1.6</span>‘the Period of Lease’ means the period of the lease specified in a Schedule.
                        </li>
                        <li>
                            <span>1.7</span>‘the Delivery Certificate’ means the delivery certificate in the form
                            provided by or on behalf of us and supplied to you.
                        </li>
                        <li>
                            <span>1.8</span>‘the Lease Agreement’ means the contract of lease between the Owner and the
                            Lessor in respect of a Vehicle, as evidenced by a Schedule and incorporating all the
                            provisions of this Master Contract Lease Agreement.
                        </li>
                        <li>
                            <span>1.9</span>‘the Distance allowed’ means the annual distance for the lease period
                            specified in a Schedule.{' '}
                        </li>
                        <li>
                            <span>1.10</span>‘the Excess Distance Charge’ means the excess distance charge specified in
                            a Schedule.
                        </li>
                    </ul>

                    <h4>2. Delivery and Acceptance</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>2.1</span>You will take delivery of the Vehicle from our representative to inspect it
                            and accept or reject it. Except where a rejection is made strictly in accordance with the
                            reason specified in Clause 2.3, you will take delivery of the Vehicle when it is ready for
                            delivery, and we will not be liable to you for any delay in delivery of the Vehicle.{' '}
                        </li>
                        <li>
                            <span>2.2</span>The Period of Lease will start when you sign the Delivery Certificate. Your
                            signing of the Delivery Certificate shall be presumed as conclusive evidence that the
                            Vehicle was properly and punctually delivered in good repair and satisfactory order, and
                            that it has been duly accepted by you.
                        </li>
                        <li>
                            <span>2.3</span>Your signing of the Lease Agreement, however, constitutes your obligation to
                            accept the Vehicle provided that it is built to the specification for the Vehicle accepted
                            by you as defined in a Schedule. If for any reason you fail to take delivery of the Vehicle
                            (save only where you are entitled to reject it if it has not been built to the specification
                            for the Vehicle accepted by you) you will be liable to pay us all sums due on early
                            termination as set out in Clause 10.3.
                        </li>
                    </ul>

                    <h4>3. Rental</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>3.1</span>You will pay to us in advance the Rental, the first Rental being payable on
                            the commencement of the Period of Lease and subsequent Rentals being payable monthly on the
                            first day of the month thereafter.
                        </li>
                        <li>
                            <span>3.2</span>The Rentals are shown exclusive of Commercial Tax. Commercial Tax will be
                            added to each Rental at the rate then prevailing and shall be payable by you. If the nature,
                            basis or rates of taxation or any other charges, duties, impositions, reliefs or allowances
                            of whatever nature change we may by notice in writing increase the Rentals paid or payable
                            under the Lease Agreement so as to maintain the after-tax return to us or to the group of
                            companies of which we are part as though no change has occurred.
                        </li>
                    </ul>

                    <h4>4. Payment</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>4.1</span>The time of all payments shall be of the essence. Payment shall be due
                            without previous demand or invoice and shall be made (without any deductions set-off or
                            counter claim) by bankers direct debit or standing order so as to be received by us in
                            cleared funds on its due date or (if the due date is not a working day) on the next working
                            day..
                        </li>
                        <li>
                            <span>4.2</span>One invoice will be issued against the Schedule on the first day of each
                            month the Schedule was initiated.{' '}
                        </li>
                        <li>
                            <span>4.2</span>In the event of late payment, five percent of the unpaid amount due will
                            additionally become due and payable for each calendar month of delay or part thereof that
                            the amount past due remains unpaid.{' '}
                        </li>
                    </ul>

                    <h4>5. Permitted Use Of Vehicle</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>5.1</span>You will only use the Vehicle as is required in the ordinary course of the
                            Lessor’s business, in accordance with the Myanmar Road Transport Administration Requirements
                            (“the Permitted Use”).
                        </li>
                        <li>
                            <span>5.2</span>You must not make any alterations to the Vehicle without our prior written
                            consent. Any additions, accessories alterations, or replacement will become our property
                            (subject to clause 5.3) and subject to the Lease Agreement.
                        </li>
                        <li>
                            <span>5.3</span>In the event that you decide to install any additional equipment or
                            accessories (having obtained our prior written consent) that improve the safety of the
                            Vehicle or facilitates your management of the fleet, you will be entitled to take them back:
                            <ul>
                                <li>
                                    <span>(i)</span>at any time prior to the expiry of the Lease Agreement, or
                                </li>
                                <li>
                                    <span>(ii)</span>if the Lease Agreement has expired, within a reasonable time
                                    following expiry of the Lease Agreement,
                                </li>
                            </ul>
                            Provided that any damage to the Vehicle arising from the removal of the equipment or
                            accessories is made good and rectified by you at your cost.
                        </li>
                        <li>
                            <span>5.4</span>In the event of early termination of the contract, we will take possession
                            of the Vehicle as stated in clause 10.2 below and you will be entitled to take your
                            accessories, equipment back at your own cost either before we take possession of the vehicle
                            within a reasonable time after, at a location to be reasonably agreed by the parties and
                            provided that any damage to the Vehicle arising from the removal of the equipment or
                            accessories is made good and rectified by you at your cost.
                        </li>
                        <li>
                            <span>5.5</span>You will not use or allow the Vehicle to be used for any purpose other than
                            the Permitted Use, including:-
                            <ul>
                                <li>
                                    <span>(i)</span>for any purpose not permitted by any policy of insurance for the
                                    time being in force relating to the Vehicle, or do or allow to be done anything
                                    whereby such insurance may be invalidated nor
                                </li>
                                <li>
                                    <span>(ii)</span>in contravention of the manufacturer’s recommendations for use nor
                                </li>
                                <li>
                                    <span>(iii)</span>in contravention of any law or regulation of the government of
                                    Myanmar.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span>5.6</span>You will not remove or interfere with any identification marks or plates
                            affixed to the Vehicle, nor permit the same.
                        </li>
                        <li>
                            <span>5.7</span>You will not remove, disconnect or interfere with the GPS or speed limiter
                            equipment fitted to the Vehicle.
                        </li>
                        <li>
                            <span>5.8</span>You will not deface the paintwork or bodywork of the Vehicle nor (without
                            our prior written consent) add or erect any painted signwriting, lettering or advertising to
                            or on the Vehicle. This restriction does not include removable decals on the Vehicle.
                        </li>
                        <li>
                            <span>5.9</span>You will ensure that we have a right of access to the Vehicle at all times
                            for inspection and removal, both during and after the Period of Lease.
                        </li>
                        <li>
                            <span>5.10</span>You will tell us immediately if you change your address. You will not
                            without our prior written consent export the Vehicle from Myanmar.
                        </li>
                        <li>
                            <span>5.11</span>You will keep the Vehicle and keys secure in your possession and will not
                            sell, charge or otherwise dispose of or abandon the Vehicle.
                        </li>
                        <li>
                            <span>5.12</span>You shall not use the Vehicle outside Myanmar without our prior written
                            consent. If the Vehicle is used outside Myanmar you will indemnify us against all claims and
                            expenses arising from use of the Vehicle outside of its Permitted Use, including the cost of
                            returning the Vehicle to Myanmar in the event of damage or mechanical breakdown to the
                            Vehicle. Our obligations under clause 7.1 below shall not apply whilst the Vehicle is
                            outside Myanmar.
                        </li>
                        <li>
                            <span>5.13</span>You will only permit drivers licensed under the Myanmar Road Transport
                            Administration regulations to drive the Vehicle. Additionally, these drivers must
                            familiarise themselves with the vehicles manufacturer’s handbook on operating the Vehicle
                            before commencing driving. All drivers must be 23 years of age and have held a valid driver
                            license for a minimum of two years to be authorised to operate the Vehicle.
                        </li>
                        <li>
                            <span>5.14</span>You will not permit drivers to continue to drive the Vehicle in the event
                            of multiple own fault accidents within 12 months.
                        </li>
                        <li>
                            <span>5.16</span>You will not permit smoking in the vehicle.
                        </li>
                    </ul>

                    <h4>6. Insurance</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>6.1</span>We will take out with a reputable insurance office and keep in force at all
                            times whilst you are in possession of the Vehicle comprehensive insurance coverage covering
                            the Vehicle against all risks in an amount equal to its full replacement value which shall
                            not at any time be less than our book value for the Vehicle at the time.
                        </li>
                        <li>
                            <span>6.2</span>Comprehensive insurance coverage shall meet the maximum liability currently
                            in force under the laws of Myanmar for third party loss, driver and passenger(s) injury the
                            Vehicle is designed for (defined by the number of seat belts fitted).
                        </li>
                        <li>
                            <span>6.3</span>For every accident a non-waivable excess of USD 300 shall be levied by us.
                            In the event of recovery from a third party, this amount will be credited to the Lessor.
                        </li>
                        <li>
                            <span>6.4</span>You have no cover and are always liable for damage or third party loss
                            caused by overhead (above the top edge of the front windscreen) or under body contact.
                        </li>
                        <li>
                            <span>6.5</span>Where any event or accident shall occur, you shall immediately notify us
                            thereof (together with details of the whereabouts of the Vehicle), you shall not compromise
                            any claim without our written consent, you shall allow us to conduct all negotiations
                            (except in relation to any claims you might have for personal injuries, loss of use of the
                            Vehicle or loss or damage to your own property). The notification is to be made to the Yoma
                            Fleet Call Centre on telephoine number 09 YOMAFLEET (09 966 235 338). The Call Centre
                            operates 24/7 and all calls/lost calls are recorded.
                        </li>
                        <li>
                            <span>6.6</span>If the Vehicle is declared a total loss by the insurer the Lease Agreement
                            shall terminate forthwith and (save for any subsisting breaches existing at the date of
                            termination) no party shall have any further right or claim against the other. Following
                            such termination, the Owner may (at its discretion), offer a new lease agreement to the
                            Lessor, on new terms to be negotiated at that time.
                        </li>
                        <li>
                            <span>6.7</span>If you have an accident in which:
                            <ul>
                                <li>
                                    <span>(i)</span>A person is injured;
                                </li>
                                <li>
                                    <span>(ii)</span>The other party failed to stop or exchange details;
                                </li>
                                <li>
                                    <span>(iii)</span>The Vehicle or any other vehicle is towed or subject to rollover;
                                    or
                                </li>
                                <li>
                                    <span>(iv)</span>A driver appears to be under the influence of intoxicating liquor
                                    or drugs
                                </li>
                            </ul>
                            a report must also be made to the police by Lessee immediately.
                        </li>
                        <li>
                            <span>6.8</span>In the event of accidents not involving the police, an accident report form
                            (provided in the vehicle) is to be fully completed and photographs are to be taken BEFORE
                            the vehicle(s) are moved. Photographs are to clearly show the position of the vehicle(s) in
                            relation to the road or surrounds of the accident and the object of the collision.
                        </li>
                        <li>
                            <span>6.9</span>We shall have the right to repair any Vehicle, which is the subject of an
                            accident.
                        </li>
                        <li>
                            <span>6.10</span>All the references to “Vehicle” in Clauses 6.1 and 6.8 above shall include
                            any replacement vehicle for the Vehicle.
                        </li>
                    </ul>

                    <h4>7. Our Service, Maintenance and Replacement Vehicle Obligations</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>7.1</span>We shall (subject to the provisions of Clause to 7.2.4 below) be responsible
                            for the costs of all servicing to the Vehicle at the intervals indicated in the service
                            interval section of the Manufacturers Handbooks. The servicing shall be carried out during
                            the normal working hours (Monday to Saturdays, but excluding public holidays) of the
                            repairing agent to whom the Vehicle is delivered for such servicing.
                            <ul>
                                <li>
                                    <span>7.1.1</span>Where the Vehicle requires maintenance and repairs resulting from
                                    the Permitted Use of the Vehicle in Myanmar, we shall be responsible for providing
                                    all rectification referred to in Clause 7.1, above even if the breakdown happens at
                                    an earlier time than the equipment’s normal time between failure.
                                </li>
                            </ul>
                        </li>

                        <li>
                            7.2 We shall supply a replacement vehicle in Myanmar only.
                            <ul>
                                <li>
                                    <span>7.2.1</span>Within a 30 kilometre radius of Yoma Fleet branches, we shall
                                    provide a replacement vehicle within no more than four hours of your notification by
                                    telephone to us, should the Vehicle suffer mechanical breakdown (not being caused by
                                    damage, abuse, misuse, neglect or your negligence)
                                </li>
                                <li>
                                    <span>7.2.2</span>Outside of the 30 kilometre radius of Yoma Fleet branches we shall
                                    provide a replacement vehicle within no more than 24 hours of your notification by
                                    telephone to us, should the Vehicle suffer mechanical breakdown (not being caused by
                                    damage, abuse, misuse, neglect or your negligence).
                                </li>
                                <li>
                                    <span>7.2.3</span>If we fail to comply with our obligation in Clauses 7.2.1, or
                                    7.2.2 above to provide a replacement vehicle we shall credit you with one day rental
                                    for each day or part thereof, that we do not supply a replacement vehicle to you. We
                                    shall not be liable for any consequential loss that you may suffer as a result of
                                    such failure.
                                </li>
                                <li>
                                    <span>7.2.4</span>Upon being notified that the Vehicle is ready for collection you
                                    shall return the replacement vehicle to your place of employment (or other mutually
                                    agreed location) from which it was obtained within 24 hours of receiving such
                                    notification, failing which you shall be liable to pay for the replacement vehicle
                                    at the normal daily lease rates for a vehicle of the same class as the replacement
                                    vehicle for each day thereafter.
                                </li>
                                <li>
                                    <span>7.2.5</span>The replacement vehicle may be of a similar type and age to the
                                    Vehicle, but our sole responsibility is to provide a replacement that is as far
                                    possible in the same category as that of the Vehicle. All the terms and conditions
                                    of the Lease Agreement shall apply to any such replacement vehicle.
                                </li>
                                <li>
                                    <span>7.2.6</span>We shall provide and pay for all tyres required to be replaced
                                    through fair wear and tear which is assessed to be more than 40,000 kilometres (but
                                    not including punctures, damage or abuse as determined by the appointed tyre repair
                                    agent). In the event of tyre replacement under 40,000 kilometres the Lessee will be
                                    billed on a pro rata basis for the assessed unused portion.
                                </li>
                                <li>
                                    <span>7.2.7</span>We shall provide and pay for windscreens required to be replaced
                                    through failure attributable to use of the Vehicle within the Permitted Use.
                                    Windscreen damage caused by an accident will be covered by the comprehensive
                                    insurance and subject to the non-waivable excess.
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <h4>8. Your Service and Maintenance Obligations</h4>

                    <ul className="tAndCList">
                        <li>
                            8.1 You shall be solely responsible at your own cost for all routine and daily maintenance
                            inspection and safety checks in respect of the Vehicle. Without prejudice to the generality
                            of the foregoing such routine and daily maintenance inspections to be carried out by you
                            shall include:
                        </li>
                        <li>
                            <ul>
                                <li>
                                    <span>8.1.1</span>regular checking and adjusting of all fluid levels, ensuring the
                                    air-cleaner is dust free, the conditions and pressure of tyres, wheel nuts (for
                                    tightness) and general roadworthiness, as per the manufacturer’s recommendations
                                    outlined in the vehicle handbook;
                                </li>
                                <li>
                                    <span>8.1.2</span>regular cleaning of the exterior, interior and upholstery of the
                                    Vehicle;{' '}
                                </li>
                                <li>
                                    <span>8.1.3</span>conducting daily checks of the primary fuel filter for water and
                                    debris, draining as necessary; and
                                </li>
                                <li>
                                    <span>8.1.4</span>regular checking of wheel alignment shall be carried out by Lessee
                                    at your expense.
                                </li>
                            </ul>
                        </li>

                        <li>
                            <span>8.2</span>You shall immediately inform us of any damage incurred to or any malfunction
                            of the Vehicle (Call Centre 09 YOMAFLEET 09 966235338 24/7). Such circumstances include, but
                            are not limited to, incorrect refuelling, the appearance of a warning light, low engine or
                            gear box oils, low brake fluid or coolant levels, or when the vehicle develops any fault. In
                            such circumstances you must not use the Vehicle unless we have authorised you to do so. If
                            you fail to notify us or continue to use the Vehicle, you will be responsible for any damage
                            incurred.
                        </li>

                        <li>
                            <span>8.3</span>You must not let anyone work on the Vehicle or arrange to undertake any
                            repairs, tow or salvage the vehicle unless we have given our prior authorisation to do so.
                        </li>

                        <li>
                            <span>8.4</span>You shall deliver the Vehicle for maintenance and repair at authorised
                            repairing agents pursuant to Clause 7.1 above and shall receive the Vehicle back once such
                            maintenance has been effected. We will arrange all such maintenance and repair by
                            appointment, and settle the resulting expenses. If you fail to submit the Vehicle promptly
                            as aforesaid our obligations under Clause 7.1 above shall cease to exist.
                        </li>

                        <li>
                            <span>8.5</span>You shall inspect any replacement vehicle offered to you and sign for its
                            specific condition, noting elements of paint and body damage. Failure to record the
                            conditions of the Vehicle could result in you being held liable for such existing damage.
                        </li>
                    </ul>

                    <h4>9. Our Liabilities and Limitations</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>9.1</span>We do not lease the Vehicle subject to any condition or warranty express,
                            implied or statutory in connection with the fitness for any purpose or age of the Vehicle or
                            otherwise and all conditions and warranties are hereby expressly excluded to the fullest
                            extent permitted by law and (save for our liability for death or personal injury caused by
                            the negligence of us, our employees or agents) we will not be responsible for any liability,
                            claim, loss, damage, or expense of any kind or nature caused directly or indirectly by the
                            Vehicle or its use.
                        </li>
                        <li>
                            <span>9.2</span>You shall be solely responsible for and hold us fully indemnified against
                            all claims, demands, liabilities, losses, damages, proceedings, costs and expenses suffered
                            or incurred by us as a result of any breach or default on your part in the discharge of your
                            obligations under the Lease Agreement.
                        </li>
                        <li>
                            <span>9.3</span>You shall be solely responsible for all traffic offences or violations of
                            parking regulations involving the Vehicle for each year or part thereof that the hiring of
                            the Vehicle shall subsist including all fines or penalties and will indemnify us in respect
                            of all such matters.
                        </li>
                        <li>
                            <span>9.4</span>You shall not use the Vehicle for the carriage of loads in excess of the
                            road regulations for the Vehicle’s load capacity, shall distribute all loads evenly thereon
                            and shall not carry any goods thereon which may damage the Vehicle or render it unfit to
                            carry other goods. You are responsible to ensure loads are adequately restrained, and
                            dunnage is used to protect the Vehicle from damage.
                        </li>
                        <li>
                            <span>9.5</span>You shall be solely responsible for all claims relating to your property and
                            cargo loss or damage.
                        </li>
                    </ul>

                    <h4>10. Termination</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>10.1</span>If you or any guarantor of your obligations shall (i) fail to pay any
                            Rental or other sum payable under the Lease Agreement in full within 14 days after it
                            becomes due, or (ii) commit a breach of any of the other terms of the Lease Agreement and
                            (if capable of remedy) shall fail to remedy such breach within 30 days after notice in
                            writing from us requiring the same, or commit breach of any other Lease Agreement or any
                            other agreement or arrangement presently existing or hereafter entered into between you or
                            the guarantor and us, or (iii) (being an individual) die or suffer an interim order (within
                            the meaning of the Insolvency Act ) to be made against you or any guarantor or enter into a
                            voluntary arrangement or suffer the making of a statutory demand or the presentation of a
                            petition for a bankruptcy order or to make any arrangements or suffer the composition with
                            your or any guarantor’s creditors, or (iv) (being a limited company) enter into compulsory
                            or voluntary liquidation or have a receiver or administrative receiver appointed to any part
                            of your or his assets or suffer the presentation of a petition for the appointment of an
                            administrator THEN you will be deemed to have repudiated this Lease Agreement. We may
                            thereupon, or at any time within 3 months after becoming aware of the same (and without
                            prejudice to any of our other rights and any further liability you may have to us and even
                            if we subsequently accept any Rentals) accept that repudiation and serve written notice on
                            you terminating the Lease Agreement immediately and for all purposes.
                        </li>
                        <li>
                            <span>10.2</span>
                            Upon termination of the Lease Agreement under Clause 10.1 above and on the expiry of the
                            Period of Lease you will no longer be in possession of the Vehicle with our consent and you
                            will:
                            <ul>
                                <li>
                                    <span>10.2.1</span>at your expense and risk return the Vehicle (together with the
                                    spare wheel(s), tools, handbook, service vouchers and ancillary equipment where
                                    fitted) to such location as we specify in good working order and condition and free
                                    from damage (fair wear and tear only excepted as per the Yoma Fleet Fair Wear and
                                    Tear Handbook) and free of all livery not authorised in writing by us. If you fail
                                    to return it within a reasonable time of being requested to do so, then we may
                                    immediately without notice retake possession of it and for this purpose shall be
                                    entitled to freely enter upon any premises occupied by you or under your control.
                                </li>
                                <li>
                                    <span>10.2.2</span>be solely responsible for ensuring the safe-keeping supervision
                                    and custody of the Vehicle until it is returned to or repossessed by us.
                                </li>
                                <li>
                                    <span>10.2.3</span>pay us together with Commercial Tax where applicable:
                                    <ul>
                                        <li>
                                            <span>10.2.3.1</span>all arrears of Rentals.
                                        </li>
                                        <li>
                                            <span>10.2.3.2</span>any costs and expenses we incur in locating
                                            repossessing or restoring the Vehicle or collecting any payments due under
                                            the Lease Agreement or otherwise obtaining due performance of your
                                            obligations including the cost of all repairs required.
                                        </li>
                                        <li>
                                            <span>10.2.3.3</span>all excess distance charges as detailed in Clause 11
                                            below.
                                        </li>
                                        <li>
                                            <span>10.2.3.4</span>all other sums due from you under this Lease Agreement.
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span>10.3</span>You may at your discretion prematurely terminate the Lease Agreement
                            (provided you are not in breach of any of the provisions of that Lease Agreement) by giving
                            to us at least one clear calendar months notice in writing and paying to us the following
                            sums:
                            <ul>
                                <li>
                                    <span>10.3.1</span>All arrears of Rentals as at the expiry of the said notice;
                                </li>
                                <li>
                                    <span>10.3.2</span>All other sums (if any) as may be due and unpaid under the Lease
                                    Agreement as at the expiry of the said notice;
                                </li>
                                <li>
                                    <span>10.3.3</span>By the way of agreed damages the amount of all Rentals which
                                    would have been payable for the Period of Lease recalculated at 20 percent of the
                                    outstanding lease fees payable as specified in the Schedule or one months lease fee,
                                    whichever is higher.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span>10.4</span>On termination under Clause 10.3 above the provisions of Clauses 10.2.1 and
                            10.2.2 above will apply.
                        </li>
                        <li>
                            <span>10.5</span>In lieu of early termination clause 10.3 being invoked for premature
                            termination, we will allow the following:
                            <ul>
                                <li>
                                    <span>10.5.1</span>Subject to satisfactory credit checks the Lease Agreement may be
                                    transferred to a new entity under the same terms and conditions for the balance of
                                    the full contract.
                                </li>
                                <li>
                                    <span>10.5.2</span>Cancellation of the contract without damages providing a buyer of
                                    the leased vehicle is found that will pay in full the then current book value of the
                                    asset.
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <h4>11. Excess Distance </h4>

                    <ul className="tAndCList">
                        <li>
                            <span>11.1</span>Annually, on the anniversary of each Schedule we shall take the then
                            correct odometer readings for the Vehicle. If the distance travelled exceeds the Schedule
                            Distance allowed for the vehicle, then you will on demand by us pay an additional rental
                            based on the relevant distance applicable.
                        </li>
                        <li>
                            <span>11.2</span>In the event that the odometer on a Vehicle(s) ceases to function properly,
                            or if the seals on the odometer have been interfered with, we will be entitled to estimate
                            the distance covered by the Vehicle(s) for the period during which the odometer shall have
                            failed to function or shall appear first to have been interfered with based on Telematic
                            data.
                        </li>
                        <li>
                            <span>11.3</span>If the Lease Agreement terminates early pursuant to Clause 10 above then
                            the distance will be calculated pro rata based on the applicable rate period threshold
                            Schedule Distance as per Clause 11.1 above.
                        </li>
                    </ul>

                    <h4>12. Fuel State</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>12.1</span>Vehicles will be supplied in a full fuel state and are to be returned in
                            the same state, or a refuelling charge will be levied.
                        </li>
                    </ul>

                    <h4>13. Telematics</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>13.1</span>The Owner may, at its sole discretion, install a telematics solution
                            ("Telematics") in the Vehicle at the Owners own cost. Telematics allows the Owner to track
                            the Vehicle by GPS as well as extract kilometres, fuel levels, acceleration and braking
                            data, as well as remotely lock / unlock or immobilise the Vehicle. By using the Vehicle, the
                            Lessee consents to the collection of such data.
                        </li>
                    </ul>

                    <h4>14. General</h4>

                    <ul className="tAndCList">
                        <li>
                            <span>14.1</span>No relaxation of these terms and conditions shall prejudice our strict
                            rights or be construed as a waiver of any of them. If any of these terms and conditions
                            becomes unenforceable in any respect the enforceability of the others shall not in any way
                            be affected or impaired. We may assign or charge this Yoma Fleet Easy Lease Agreement or any
                            Lease Agreement and our rights in the Vehicle.
                        </li>
                        <li>
                            <span>14.2</span>All notices shall be in writing and shall be duly served when delivered (in
                            the case of personal delivery or letter) and when despatched (in the case of email) to the
                            other party addressed to it at its address or number (if any) specified herein or at such
                            address or number as it may specify for such purpose to the other by notice in writing. A
                            notice received on a day other than a working day or after business hours shall be deemed to
                            be served on the next working day.
                        </li>
                        <li>
                            <span>14.3</span>No variation to this Yoma fleet Easy Lease Agreement or to any Lease
                            Agreement shall be of any force or effect unless in writing signed by an authorised person
                            on behalf of each of us.
                        </li>
                        <li>
                            <span>14.4</span>This Yoma Fleet Easy Lease Agreement and each Lease Agreement shall be
                            governed by and construed in accordance with the laws of the Union of Myanmar.
                        </li>
                        <li>
                            <span>14.5</span>We reserve the right to exchange the Vehicle where we in our absolute
                            discretion consider it is not suitable for your operation which shall include, without
                            prejudice to the generality of the foregoing, where the Vehicle has incurred an
                            exceptionally high mileage (bearing in mind the Schedule Distance), any abuse, or where the
                            costs of maintaining the Vehicle are considered by us to be uneconomical.
                        </li>
                        <li>
                            <span>14.6</span>All disputes arising out or in connection with this Agreement which were
                            not settled amicably between the Parties shall be referred to and finally resolved by
                            arbitration at Union of Myanmar Federation of Chambers of Commerce and Industry (“UMFCCI”)
                            Yangon in accordance with the Arbitration Law 2016 (Law 5/2016 – the Arbitration Law) or any
                            amending or superseding legislation in force at the time. The arbitration proceedings shall
                            be conducted in the English language and any decision or award rendered by the arbitration
                            tribunal shall be written in the English language.
                        </li>
                    </ul>
                </div>

                <div className="agreeTerms">
                    <Checkbox
                        id="subscription-contract-check"
                        name="agree_trems"
                        value="1"
                        ref={register({ required: true })}
                        onChange={handleCheck}
                    >
                        I have read and agreed Easy Lease Agreement.
                    </Checkbox>

                    <div className="form-error">
                        {errors.agree_trems && (
                            <span className="formFieldError">You must agree with terms and conditions.</span>
                        )}
                    </div>
                </div>

                <div className="subscriptionContentContainerSteps">
                    <MuiButton className="secondary-btn profilePrev" onClick={() => onBack()}>
                        back
                    </MuiButton>
                    <MuiButton
                        test_id="subscription-contract-submit"
                        disabled={!checker}
                        className="secondary-btn profileNext"
                        type="submit"
                    >
                        next
                    </MuiButton>
                </div>
            </form>

            <Affix offsetBottom={0}>
                <div className="formStepper">
                    <img src={car} alt="Car" className="formStepperCar step7" />
                    <img src={road} alt="Road" className="formStepperRoad" />
                </div>
            </Affix>
        </div>
    );
};

export default ContractForm;
